/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Style from './DuvidasFrequentes25Canais.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';

function DuvidasFrequentes25Canais() {
  const [showMsg, setShowMsg] = useState(false);
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="duvidas-frequentes25-canais">
        <ContainerHome24>
          <div className="canais-principal">
            <div className="canais-textos">
              <h2 className="canais-titulo">Canais oficiais</h2>
              {typeof window === 'undefined' ? (
                <></>
              ) : (
                <>
                  {width < 992 && (
                    <p className="canais-texto">
                      Você consegue fazer tudo o que faria em uma agência Santander:
                    </p>
                  )}
                  {width >= 992 && (
                    <p className="canais-texto">Você também pode falar em nossos outros canais.</p>
                  )}
                </>
              )}
            </div>
            <div className="canais-carrossel">
              <CustomEmblaCarouselHome24
                // loop
                enableBullets
                detectBulletCount
                // hideOverflow
                enableMobileArrows
                enablePrevArrow
                //autoplay={100000}
              >
                {({ className }) => (
                  <>
                    <div className={`slide ${className}`}>
                      <a
                        href="https://www.santander.com.br/hotsite/santanderfinanciamentos/sandbox.html?ori=portalSF&int_source=faq&redirect=https://api.whatsapp.com/send?phone=551140049090&text=Ol%C3%A1%20Santander%20Financiamentos"
                        target="_blank"
                        className="slide-contain"
                      >
                        <div className="canais-card-img-titulo">
                          <img src="assets/duvidas-frequentes25/ic-whatsapp.svg" alt="" />
                          <p className="canais-card-titulo">
                            Whatsapp <ins>11 4004-9090</ins>
                          </p>
                        </div>
                        <p className="canais-card-link">Acessar</p>
                        {typeof window === 'undefined' ? (
                          <></>
                        ) : (
                          <>
                            {width >= 992 && (
                              <picture className="qrcode-whatsapp">
                                <source
                                  type="image/webp"
                                  srcSet="assets/duvidas-frequentes25/qrcode-whatsapp-faq.webp"
                                />
                                <source
                                  type="image/png"
                                  srcSet="assets/duvidas-frequentes25/qrcode-whatsapp-faq.png"
                                />
                                <img
                                  src="assets/duvidas-frequentes25/qrcode-whatsapp-faq.png"
                                  alt="qrcode whatsapp"
                                />
                              </picture>
                            )}
                          </>
                        )}
                      </a>
                    </div>
                    <div className={`slide ${className}`}>
                      <a href="tel:4004-9090" target="_blank" className="slide-contain">
                        <div className="canais-card-img-titulo">
                          <img src="assets/duvidas-frequentes25/ic-central.svg" alt="" />
                          <p className="canais-card-titulo">Central de relacionamento</p>
                        </div>
                        <p className="canais-card-link">4004-9090</p>
                      </a>
                    </div>
                    <div className={`slide ${className}`}>
                      <a
                        href="https://www.cliente.santanderfinanciamentos.com.br/portalcliente/#/loginCollection?ori=SF&int_source=pagina-faq"
                        target="_blank"
                        className="slide-contain"
                      >
                        <div className="canais-card-img-titulo">
                          <img src="static/amp/shared/assets/ic_dealer_reseller.svg" alt="" />
                          <p className="canais-card-titulo">Portal de Renegociação</p>
                        </div>
                        <p className="canais-card-link">Acessar</p>
                      </a>
                    </div>
                  </>
                )}
              </CustomEmblaCarouselHome24>
            </div>
          </div>
        </ContainerHome24>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default DuvidasFrequentes25Canais;
